// extracted by mini-css-extract-plugin
export default {"cont":"Success_cont__hoCbR","box":"Success_box__9VCDy","head":"Success_head__cOeLb","btn":"Success_btn__TOa6w","imag":"Success_imag__HebRV"};